import { createFileRoute, redirect } from '@tanstack/react-router';
import { AppShell } from '@/components/layout/app-shell';
import { supabase } from '@/lib/supabase';

// _app es un "pathless layout group" — la URL no incluye /_app, sólo aplica
// el shell a sus children. beforeLoad protege todas las rutas adentro.
export const Route = createFileRoute('/_app')({
  component: AppShell,
  beforeLoad: async () => {
    const { data } = await supabase.auth.getSession();
    if (!data.session) {
      throw redirect({ to: '/login' });
    }
    return {
      userId: data.session.user.id,
      userEmail: data.session.user.email ?? null,
    };
  },
});
